<template>
<div>
<loading :active.sync="isLoading"></loading>
<Header />
<div id="kv" class="faq">
  <h1>よくあるご質問</h1>
</div>
<main>
  <section class="content page_faq">
    <div class="container">
      <div class="box_faq">
        <dl>
          <dt>マジェスティ オーナーズクラブとは。</dt>
          <dd>マジェスティ オーナーズクラブは「 MAJESTY 」のゴルフクラブを購入し、登録していただいた方のみ入会できる会員組織です。様々な特典が用意されているだけでなく、オーナー様とマジェスティゴルフ、またはオーナー様同士の交流の場として豊かなゴルフライフを提供するために運営しています。</dd>
        </dl>
        <dl>
          <dt>入会費・年会費はかかりますか。</dt>
          <dd>かかりません。</dd>
        </dl>
        <dl>
          <dt>メンバー期限はありますか。</dt>
          <dd>ございません。</dd>
        </dl>
        <dl>
          <dt>入会条件はありますか。</dt>
          <dd>マジェスティのゴルフクラブをご購入いただいたすべての方に権利がございます。</dd>
        </dl>
        <dl>
          <dt>クラブの退会方法</dt>
          <dd>退会をご希望の方は、<a href="mailto:majesty_ownersclub@majesty-golf.com">majesty_ownersclub@majesty-golf.com</a>までご連絡ください。</dd>
        </dl>
        <dl>
          <dt>ログインできません。</dt>
          <dd>ログインIDであるご登録のメールアドレスまたはパスワードが正しく入力されているかご確認ください。<!-- パスワードをお忘れの方は<a href="/login/login_reset.html">こちら</a>から再設定いただけます。--></dd>
        </dl>
        <dl>
          <dt>クラブのシリアルナンバーがわかりません。</dt>
          <dd>シリアルナンバーはシャフトに添付されているシールに10桁の英数字（または8桁）で印字されています。シールが無い場合はシャフトに刻印されている10桁または8桁の英数字をご確認ください。
            <div class="imgArea img02"><img src="/assets/images/product/sample.jpg"></div>
          </dd>
        </dl>
        <dl>
          <dt>グリップ交換特典を使用したかどうか確認したいのですが、どうしたらよいでしょうか。</dt>
          <dd><a href="/login/mybag/">ご登録クラブの確認ページ</a>から、対象となるご登録のクラブの項目から「グリップ交換」をクリックして修理の相談フォームに進んでください。 </dd>
        </dl>
        <dl>
          <dt>会員の権利は譲渡できますか。</dt>
          <dd>できません。</dd>
        </dl>
        <dl>
          <dt>中古クラブは登録できますか。</dt>
          <dd>できません。</dd>
        </dl>
        <dl>
          <dt>もらったクラブは登録できますか。</dt>
          <dd>できません。</dd>
        </dl>
        <!-- dl>
          <dt>住所変更の方法</dt>
          <dd>ログイン後、<a href="/login/account/change/">こちら</a>から変更いただけます。</dd>
        </dl -->
        <!-- dl>
          <dt>メールアドレス変更の方法</dt>
          <dd>ログイン後、<a href="/login/email/change/">こちら</a>から変更いただけます。</dd>
        </dl>
        <dl -->
          <!-- dt>メールが来ない。</dt>
          <dd>ご登録メールアドレスに間違いがないかを<a href="/login/email/change/">こちら</a>からご確認ください。また、受信拒否設定またはスパムフォルダに振り分けられていないかご確認ください。</dd>
        </dl -->
        <dl>
          <dt>本サイト以外の会員登録方法</dt>
          <dd>ご購入いただいたクラブに添付されている専用の登録はがきに必要事項をご記入の上投函いただければご登録いただけます。</dd>
        </dl>
      </div>
    </div>
  </section>
</main>
<Footer />
</div>
</template>

<script>
import Footer from './footer'
import Header from './header'
import Loading from 'vue-loading-overlay'

export default {
  data: function () {
    return {
      isLoading: false
    }
  },
  components: {
    Footer,
    Header,
    Loading
  }
}
</script>
